// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../media/fonts/dana-medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../media/fonts/dana-medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../media/fonts/dana-medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../media/fonts/TahrirMedium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../media/fonts/TahrirMedium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../media/fonts/TahrirMedium.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fade-in {
  from {
    opacity: 0; }
  to {
    opacity: 1; } }

@keyframes fade-in-long {
  0% {
    opacity: 0; }
  50% {
    opacity: 0.5; }
  100% {
    opacity: 1; } }

@font-face {
  font-family: "Dana";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: normal;
  font-style: normal;
  font-display: swap; }

@font-face {
  font-family: "Tahrir";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2");
  font-weight: normal;
  font-style: normal;
  font-display: swap; }

body {
  direction: ltr;
  padding: 0;
  margin: 0;
  overflow: hidden;
  color: var(--black-color);
  font-size: 12px;
  font-family: "my-font", serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-tap-highlight-color: transparent;
  -webkit-font-smoothing: antialiased;
  line-height: 1.7; }
  @media screen and (min-width: 450px) {
    body {
      background-color: var(--solid-dark) !important; }
      body #root {
        transform: translate3d(0, 0, 0);
        max-width: var(--desktop-viewport);
        height: var(--full-height);
        margin: 0 auto; } }
  body .index-temp {
    display: inline-block;
    width: 100%;
    height: 100vh;
    background-color: var(--white-color); }

* {
  -webkit-appearance: none;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  color: inherit;
  text-align: inherit;
  background-color: transparent;
  font-size: inherit;
  font-family: inherit;
  border: none;
  font-weight: normal; }
  *:focus {
    outline: none; }

h1,
h2,
h3,
h4 {
  font-family: "Dana", serif; }

a {
  color: inherit;
  text-decoration: none;
  display: block; }

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0; }

::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  border-radius: 4px; }

::-webkit-scrollbar-track {
  border-radius: 4px;
  background-color: transparent; }

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(165, 165, 165, 0.356); }

::-webkit-scrollbar-thumb:hover {
  background-color: var(--first-color); }

::selection {
  color: white;
  background: var(--first-color); }

.hide-scroll {
  -ms-overflow-style: none;
  scrollbar-width: none; }
  .hide-scroll::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0; }

.highlight {
  background-color: #fbc02d; }

textarea {
  overflow-y: scroll !important; }

.conditions ::-webkit-scrollbar {
  width: 4px;
  height: 2px;
  border-radius: 4px; }

.conditions ::-webkit-scrollbar-track {
  border-radius: 4px;
  background-color: #e0e0e0; }

.conditions ::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #616161; }

iframe {
  display: none; }

.animateContainer {
  position: relative;
  width: 200px;
  height: 20px;
  padding: auto 60px;
  display: grid;
  grid-template-columns: repeat(3, 60px);
  justify-content: center;
  justify-items: center;
  align-items: center;
  width: 100%;
  margin-top: 10px; }

.animateContainer .circleCell {
  width: 16px;
  height: 16px;
  background: white;
  border-radius: 50%; }

.animateContainer .circleCell:nth-child(1) {
  animation: circleAnimation 2s cubic-bezier(0.38, 0.08, 0.25, 1.08) infinite -0.6s; }

.animateContainer .circleCell:nth-child(2) {
  animation: circleAnimation 2s cubic-bezier(0.38, 0.08, 0.25, 1.08) infinite -0.3s; }

.animateContainer .circleCell:nth-child(3) {
  animation: circleAnimation 2s cubic-bezier(0.38, 0.08, 0.25, 1.08) infinite; }

@keyframes circleAnimation {
  0% {
    opacity: 0;
    transform: scale(1); }
  50% {
    opacity: 1;
    background: #00897b;
    transform: scale(1.3); }
  100% {
    opacity: 0;
    transform: scale(0.4); } }
`, "",{"version":3,"sources":["webpack://./src/styles/animations.scss","webpack://./src/styles/index.scss"],"names":[],"mappings":"AAAA;EACE;IACE,UAAU,EAAA;EAEZ;IACE,UAAU,EAAA,EAAA;;AAId;EACE;IACE,UAAU,EAAA;EAEZ;IACE,YAAY,EAAA;EAEd;IACE,UAAU,EAAA,EAAA;;ACfd;EACE,mBAAmB;EACnB,4CAA0C;EAAE,qBAAA;EAC5C,oHACyD;EACzD,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB,EAAA;;AAEpB;EACE,qBAAqB;EACrB,4CAA2C;EAAE,qBAAA;EAC7C,oHAC0D;EAC1D,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB,EAAA;;AAGpB;EACE,cAAc;EACd,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,6BAA6B;EAC7B,kCAAkC;EAClC,wCAAwC;EACxC,mCAAmC;EACnC,gBAAgB,EAAA;EAChB;IAZF;MAaI,8CAA8C,EAAA;MAblD;QAiBM,+BAA+B;QAC/B,kCAAkC;QAClC,0BAA0B;QAC1B,cAAc,EAAA,EACf;EArBL;IAwBI,qBAAqB;IACrB,WAAW;IACX,aAAa;IACb,oCAAoC,EAAA;;AAIxC;EACE,wBAAwB;EACxB,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB,EAAA;EAXrB;IAgBI,aAAa,EAAA;;AAIjB;;;;EAIE,0BAA0B,EAAA;;AAG5B;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc,EAAA;;AAGhB;;EAEE,wBAAwB;EACxB,SAAS,EAAA;;AAGX;EACE,UAAU;EACV,WAAW;EACX,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,6BAA6B,EAAA;;AAG/B;EACE,kBAAkB;EAClB,4CAA4C,EAAA;;AAG9C;EACE,oCAAoC,EAAA;;AAStC;EACE,YAAY;EACZ,8BAA8B,EAAA;;AAGhC;EACE,wBAAwB;EACxB,qBAAqB,EAAA;EAFvB;IAKI,aAAa;IACb,QAAQ;IACR,SAAS,EAAA;;AAIb;EACE,yBAAyB,EAAA;;AAE3B;EACE,6BAA6B,EAAA;;AAG/B;EAEI,UAAU;EACV,WAAW;EACX,kBAAkB,EAAA;;AAJtB;EAQI,kBAAkB;EAClB,yBAAyB,EAAA;;AAT7B;EAaI,kBAAkB;EAClB,yBAAyB,EAAA;;AAI7B;EACE,aAAa,EAAA;;AAGf;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sCAAsC;EACtC,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,gBAAgB,EAAA;;AAElB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB,EAAA;;AAEpB;EACE,iFAAiF,EAAA;;AAEnF;EACE,iFAAiF,EAAA;;AAEnF;EACE,2EAA2E,EAAA;;AAG7E;EACE;IACE,UAAU;IACV,mBAAmB,EAAA;EAErB;IACE,UAAU;IACV,mBAAmB;IACnB,qBAAqB,EAAA;EAEvB;IACE,UAAU;IACV,qBAAqB,EAAA,EAAA","sourcesContent":["@keyframes fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fade-in-long {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 0.5;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n","@import \"animations\";\n\n@font-face {\n  font-family: \"Dana\";\n  src: url(\"../media/fonts/dana-medium.eot\"); /* IE9 Compat Modes */\n  src: url(\"../media/fonts/dana-medium.woff\") format(\"woff\"),\n    url(\"../media/fonts/dana-medium.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: \"Tahrir\";\n  src: url(\"../media/fonts/TahrirMedium.eot\"); /* IE9 Compat Modes */\n  src: url(\"../media/fonts/TahrirMedium.woff\") format(\"woff\"),\n    url(\"../media/fonts/TahrirMedium.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\nbody {\n  direction: ltr;\n  padding: 0;\n  margin: 0;\n  overflow: hidden;\n  color: var(--black-color);\n  font-size: 12px;\n  font-family: \"my-font\", serif;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-font-smoothing: antialiased;\n  line-height: 1.7;\n  @media screen and (min-width: 450px) {\n    background-color: var(--solid-dark) !important;\n    // min-height: 100vh;\n\n    #root {\n      transform: translate3d(0, 0, 0);\n      max-width: var(--desktop-viewport);\n      height: var(--full-height);\n      margin: 0 auto;\n    }\n  }\n  .index-temp {\n    display: inline-block;\n    width: 100%;\n    height: 100vh;\n    background-color: var(--white-color);\n  }\n}\n\n* {\n  -webkit-appearance: none;\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n  color: inherit;\n  text-align: inherit;\n  background-color: transparent;\n  font-size: inherit;\n  font-family: inherit;\n  border: none;\n  font-weight: normal;\n  // -webkit-user-select: none; /* Safari */\n  // -ms-user-select: none; /* IE 10 and IE 11 */\n  // user-select: none; /* Standard syntax */\n  &:focus {\n    outline: none;\n  }\n}\n\nh1,\nh2,\nh3,\nh4 {\n  font-family: \"Dana\", serif;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n  display: block;\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n::-webkit-scrollbar {\n  width: 0px;\n  height: 0px;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-track {\n  border-radius: 4px;\n  background-color: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  background-color: rgba(165, 165, 165, 0.356);\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background-color: var(--first-color);\n}\n\n::-moz-selection {\n  /* Code for Firefox */\n  color: white;\n  background: var(--first-color);\n}\n\n::selection {\n  color: white;\n  background: var(--first-color);\n}\n\n.hide-scroll {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n    width: 0;\n    height: 0;\n  }\n}\n\n.highlight {\n  background-color: #fbc02d;\n}\ntextarea {\n  overflow-y: scroll !important;\n}\n\n.conditions {\n  ::-webkit-scrollbar {\n    width: 4px;\n    height: 2px;\n    border-radius: 4px;\n  }\n\n  ::-webkit-scrollbar-track {\n    border-radius: 4px;\n    background-color: #e0e0e0;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    border-radius: 4px;\n    background-color: #616161;\n  }\n}\n\niframe {\n  display: none;\n}\n\n.animateContainer {\n  position: relative;\n  width: 200px;\n  height: 20px;\n  padding: auto 60px;\n  display: grid;\n  grid-template-columns: repeat(3, 60px);\n  justify-content: center;\n  justify-items: center;\n  align-items: center;\n  width: 100%;\n  margin-top: 10px;\n}\n.animateContainer .circleCell {\n  width: 16px;\n  height: 16px;\n  background: white;\n  border-radius: 50%;\n}\n.animateContainer .circleCell:nth-child(1) {\n  animation: circleAnimation 2s cubic-bezier(0.38, 0.08, 0.25, 1.08) infinite -0.6s;\n}\n.animateContainer .circleCell:nth-child(2) {\n  animation: circleAnimation 2s cubic-bezier(0.38, 0.08, 0.25, 1.08) infinite -0.3s;\n}\n.animateContainer .circleCell:nth-child(3) {\n  animation: circleAnimation 2s cubic-bezier(0.38, 0.08, 0.25, 1.08) infinite;\n}\n\n@keyframes circleAnimation {\n  0% {\n    opacity: 0;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    background: #00897b;\n    transform: scale(1.3);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(0.4);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
